import api from '../setup/axios';
import config from '../setup/config';

export default {
  /**
   * @typedef Role
   * @type {object}
   * @property {number} [roleId] Role ID
   * @property {string} name Role name
   * @property {string} description Role description
   */
  
  /**
   * List available roles
   * @returns { Array } List of roles and permissions attached to it
   */
  async getRoles() {
    const path = `${config.microservices.chatApi}/roles`;
    const { data } = await api.get(path);

    return data;
  },
  
  /**
   * Saves a role
   * @param { Role } role Object containing 
   * @returns { Role } Role data inserted
   */
  async saveRole(role) {
    const path = `${config.microservices.chatApi}/roles`;

    const { data } = await api.post(path, role);

    return data;
  },
  
  /**
   * Updates a role
   * @param { Role } role Role data
   * @returns { Role } Role data updated
   */
  async updateRole(role) {
    const path = `${config.microservices.chatApi}/roles/${role.roleId}`;

    const { data } = await api.put(path, role);

    return data;
  },
}
